<template>
  <x-page :title="isView ? '我的地址' : '选择地址'">
    <template slot="extra">
      <span :class="_.manage" @click="useManage = !useManage">{{
        !useManage ? '管理' : '取消'
      }}</span>
    </template>
    <div :class="_.page">
      <div v-if="!isView" :class="_.current">
        <div :class="_.label">当前配送至</div>
        <div :class="_.value">
          <van-icon name="location" :class="_.icon" />
          <CurrentLocationText />
        </div>
      </div>

      <div v-if="!isView" :class="_.title">从我的收货地址选择</div>

      <div :class="_.list">
        <x-waterfall
          ref="list"
          :manual="true"
          :auto-fit="true"
          :load="loadData"
          :no-complete-tips="true"
        >
          <template #empty>
            <x-empty type="地址" message="您还没有添加地址信息，快去添加吧" />
          </template>
          <template #default="{ data }">
            <div
              v-for="item in data"
              :key="item.id"
              :class="_.item"
              @click="isView ? handleEditClick(item) : handleItemClick(item)"
            >
              <div :class="_.hd">
                <div :class="_.name">{{ item.receiver }}</div>
                <div :class="_.phoneNumber">{{ item.phoneNo }}</div>
              </div>
              <div :class="_.bd">
                <div v-if="item.defaultFlag" :class="[_.tag, _.default]">
                  默认
                </div>
                <div v-if="!item.serviceFlag" :class="[_.tag, _.unavailable]">
                  不在服务范围
                </div>
                <div :class="_.address">
                  {{
                    `${item.province} ${item.city} ${item.county} ${item.street} ${item.detail}`
                  }}
                </div>
              </div>
              <div :class="[_.ft, _._hairlineTop]">
                <div
                  v-if="!useManage"
                  :class="_.action"
                  @click.stop="handleEditClick(item)"
                >
                  <img src="./images/编辑.png" :class="_.icon" />
                  编辑
                </div>

                <template v-else>
                  <div
                    :class="[_.action, _.del]"
                    @click.stop="handleDeleteClick(item)"
                  >
                    <img src="./images/删除1.png" :class="_.icon" />
                    删除
                  </div>
                  <div
                    :class="[_.action, _.copy]"
                    @click.stop="handleCopyClick(item)"
                  >
                    <img src="./images/复制.png" :class="_.icon" />
                    复制
                  </div>
                </template>
              </div>
            </div>
          </template>
        </x-waterfall>
      </div>

      <div :class="_.actions">
        <div :class="_.button" @click="handleAddClick">
          <img src="./images/新增.png" :class="_.icon" />
          添加地址
        </div>
      </div>
    </div>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { AddressBridge, CurrentLocationText } from './bridge'
  import {
    apiBasicAddressDelete,
    apiCommodityCommonCommodityAddressList,
  } from '@/api'
  import { copyText } from '@dcb/utils'
  import { Dialog, Toast } from 'vant'
  import { mapQuery, submit } from '@/utils'
  import { navigateBack, navigateTo } from '@/router'

  export default Vue.extend({
    noKeepalive: true,

    components: { CurrentLocationText },

    mixins: [
      mapQuery({
        isView: 'isView',
        goodsIds: {
          key: 'goodsIds',
          json: true,
        },
        addressId: {
          key: 'addressId',
          json: false,
        },
      }),
    ],

    data() {
      return {
        useManage: false,
        addressData: [],
      }
    },

    activated() {
      this.$reloadWaterfall('list')
    },

    methods: {
      loadData({ pageNumber }) {
        return pageNumber > 1
          ? []
          : apiCommodityCommonCommodityAddressList({
              commodityIds: this.goodsIds,
            })
      },
      handleItemClick(item) {
        if (!item.serviceFlag) return Toast('当前地址不在服务范围')
        AddressBridge.setCurrentLocation(item)
        AddressBridge.setChosenAddress(item)
        navigateBack()
      },
      async handleDeleteClick(item) {
        await Dialog.confirm({
          title: '确认删除该收获地址吗？',
          confirmButtonColor: '#FF960A',
        })
        submit(async $ => {
          await $.start('删除中...')
          await apiBasicAddressDelete({
            id: item.id,
          })
          if (item.id === this.addressId) {
            AddressBridge.setCurrentLocation()
            AddressBridge.setChosenAddress()
          }
          await this.$reloadWaterfall('list')
          await $.success('删除成功')
        })
      },
      async handleCopyClick(item) {
        const address = `${item.province} ${item.city} ${item.county} ${item.street} ${item.detail}`
        copyText(address)
        Toast('复制成功')
      },
      handleAddClick() {
        navigateTo('AddressEdit')
      },
      handleEditClick(item) {
        navigateTo('AddressEdit', {
          id: item.id,
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .manage {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 17px;
    color: #333333;
    line-height: 24px;
    text-align: right;
    font-style: normal;
    cursor: pointer;
  }
  .page {
    height: 100%;
    box-sizing: border-box;
    padding: 12px 12px 0 12px;
    display: flex;
    flex-direction: column;

    .current {
      flex-shrink: 0;

      .label {
        font-size: 14px;
        color: #888888;
        margin-bottom: 8px;
      }

      .value {
        background: #ffffff;
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #222222;
        padding: 12px;
        border-radius: 8px;

        .icon {
          margin-right: 5px;
        }
      }
    }

    .title {
      flex-shrink: 0;
      font-size: 14px;
      color: #888888;
      margin-bottom: 8px;

      &:not(:first-child) {
        margin-top: 16px;
      }
    }

    .list {
      flex-grow: 1;
      overflow: auto;

      .item {
        padding: 12px;
        background-color: white;
        border-radius: 8px;

        &:not(:first-child) {
          margin-top: 12px;
        }

        .hd {
          display: flex;
          align-items: center;

          .name {
            flex-grow: 1;
            font-size: 15px;
            color: #333333;
          }

          .phoneNumber {
            flex-shrink: 0;
            font-size: 15px;
            color: #333333;
          }
        }

        .bd {
          margin-top: 8px;
          padding-bottom: 4px;
          display: block;

          .tag {
            height: 14px;
            border-radius: 7px;
            padding: 0 5px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 10px;
            margin-right: 4px;

            &.default {
              background: rgba(#16bbbf, 0.1);
              color: #16bbbf;
            }

            &.unavailable {
              background: #999999;
              color: white;
            }
          }

          .address {
            display: inline;
            font-size: 12px;
            color: #666666;
            line-height: 17px;
          }
        }

        .ft {
          display: flex;
          align-items: center;
          justify-content: space-around;
          padding-top: 12px;

          .action {
            display: flex;
            align-items: center;
            font-size: 13px;
            color: #333333;
            margin-left: 24px;
            &.del {
              color: #ff3b30;
            }
            &.copy {
              color: #16bbbf;
            }

            .icon {
              width: 18px;
              height: 18px;
              user-select: none;
              -webkit-touch-callout: none;
              margin-right: 4px;
            }

            &:active {
              opacity: 0.8;
            }
          }
        }
      }
    }

    .actions {
      flex-shrink: 0;
      padding: 12px;
      user-select: none;

      .button {
        height: 50px;
        background: #ff960a;
        border-radius: 1000px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
        color: #ffffff;

        .icon {
          width: 14px;
          height: 14px;
          user-select: none;
          -webkit-touch-callout: none;
          margin-right: 4px;
        }

        &:active {
          filter: contrast(0.9);
        }
      }
    }
  }
</style>
